// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const SelectActionsheetSectionList = createStyle({
  w: '$full',
  h: 'auto',
});
